import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Progress, Row, Col, Tooltip } from 'antd';
import { cancelUploadWorkflow, changeDisableStatus } from '../../PdnSider/Upload/action';
import './style.css';

class UploadMonitor extends Component {

  constructor(props) {
    super(props);
    this.state = {}
    this.scrollRef = createRef();
    this.dialogRoot = document.getElementById('root');
  }

  scrollToBottom = () => {
    this.scrollRef.scrollIntoView({ behavior: "auto" });
  }

  componentDidMount() {
    const { tabVisible } = this.props;
    tabVisible && this.scrollToBottom();
  }

  componentDidUpdate() {
    const { tabVisible } = this.props;
    tabVisible && this.scrollToBottom();
  }

  cancelWorkflow = (e) => {
    e.stopPropagation();
    //cancel upload workflow
    const { uploadWorkflowId } = this.props;
    if (uploadWorkflowId) {
      this.props.cancelUploadWorkflow(uploadWorkflowId);
      this.props.changeDisableStatus(false);
    }
  }

  render() {
    const { visible, msg, uploadProgress, transProgress, monitor,
      endMsg, projectName,
      uploadProjectId, currentProjectId, compressProgress } = this.props;
    const progressStyle = monitor ? 0 : 20;

    return (
      <Fragment>
        <Row className='my-pdn-monitor-holygrail' span={visible ? 18 : 4}>
          <Col className='pdn-simulation-msg'
            span={7}>
            {projectName && <div className='pdn-simulation-span pdn-simulation-project'>
              <span className='font-bold span-msg-project'>Project </span>
              <span className='span-msg'>{projectName}</span>
            </div>}
          </Col>
          <Col className='my-pdn-middle' span={12} style={{ marginLeft: progressStyle }}>
            {uploadProjectId === currentProjectId && visible && <div className='my-pdn-monitor-progress'>
              {compressProgress > -1 && compressProgress <= 100 && uploadProgress <= 0 ?
                <Progress
                  size={{ height: 12 }}
                  strokeColor={'#f5850d'}
                  percent={compressProgress}
                  format={(percent) => `Compressing: ${percent}%`}
                  className="monitor-upload-progress-bar"
                />
                :
                <Progress
                  size={{ height: 12 }}
                  strokeColor={'#1890ff'}
                  percent={uploadProgress}
                  success={{ percent: transProgress }}
                  format={(percent, successPercent) => `Uploading: ${percent}% / Compiling: ${successPercent}%`}
                  className="monitor-upload-progress-bar"
                />}
            </div>}
          </Col>
          <div className='pdn-simulation-btn'>
            {uploadProjectId === currentProjectId && transProgress > -1 && <div className='pdn-simulation-button'>
              <Tooltip title='Cancel upload PCB' classNames={{ root: 'icon-tooltip' }}>
                <span className='iconfont icon-cancel9' onClick={(e) => this.cancelWorkflow(e)}></span>
              </Tooltip>
            </div>}
          </div>
        </Row>
        <div className='my-pdn-monitor'>
          <div className='my-pdn-monitor-log'>
            {uploadProjectId === currentProjectId && (monitor || msg) && <pre style={{ margin: 20, overflow: 'unset' }}>
              {msg}
              <br />
              {/* {monitor} */}
              {<ul style={{ paddingLeft: 34, margin: 0 }}>
                {monitor && monitor.length > 0 && monitor.map(item =>
                  <li key={item.id} style={{ listStyle: 'none', width: '100%' }}>
                    <p style={{ margin: 0 }}>{item.time}  {item.log}</p>
                  </li>)}
              </ul>}
              {endMsg}
            </pre>}
            <div ref={(el) => { this.scrollRef = el; }}></div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapState = (state) => {
  const { project: { currentProjectId } } = state.PDNReducer;
  const { visible, uploadProgress, transProgress, msg, monitor, uploadProjectId,
    endMsg, uploadDesignId, uploadWorkflowId, compressProgress } = state.PDNReducer.PDNUploadReducer;
  /* const { tabVisible, projectName } = state.PDNReducer.TabMonitorReducer; */
  const { projectName, tabVisible } = state.TabMonitorReducer;
  return {
    visible,
    msg,
    uploadProgress,
    transProgress,
    monitor,
    uploadProjectId,
    endMsg,
    uploadDesignId,
    tabVisible,
    projectName,
    currentProjectId,
    uploadWorkflowId,
    compressProgress
  }
}

const mapDispatch = (dispatch) => ({
  cancelUploadWorkflow(workflowId) {
    dispatch(cancelUploadWorkflow(workflowId));
  },
  changeDisableStatus(disabled) {
    dispatch(changeDisableStatus(disabled))
  }
})

export default connect(mapState, mapDispatch)(UploadMonitor);